@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.wrapperFilterEmpty {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
}

.emptyTitle {
  @include t.text(16px, 20px, 600);
  text-align: center;
}

.emptyContentWrapper {
  background-color: v.$palette-white;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
